import { motion } from "framer-motion";
import { EyeOff, FileCheck, Users, Compass } from "lucide-react";
const painPoints = [{
  icon: EyeOff,
  title: "El Impuesto a la Invisibilidad",
  description: "Tu silencio financia el crecimiento de tu competencia. Si sos el referente pero no lo comunicás, sos el secreto mejor guardado de tu industria."
}, {
  icon: FileCheck,
  title: "La Brecha de Percepción",
  description: "Tu imagen actual es un traje que ya te queda chico. Te perciben por lo que eras, no por la magnitud de lo que sos hoy."
}, {
  icon: Users,
  title: 'El Techo del "Boca en Boca"',
  description: "La recomendación te trajo hasta acá, pero ya no es suficiente. Estás perdiendo territorio frente a competidores que, con menos trayectoria, tienen más alcance."
}, {
  icon: Compass,
  title: "El Vacío de Dirección",
  description: "Tu empresa escaló, pero tu comunicación se quedó atrás. Sin una dirección estratégica alineada a tu visión, el crecimiento corre peligro."
}];
const Challenge = () => {
  return <section className="py-24 md:py-32 relative overflow-hidden bg-background" id="desafio">
      <div className="container px-4">
        {/* Section header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-4xl mx-auto mb-12">
          <span className="text-primary text-sm font-semibold tracking-widest uppercase mb-4 block">
            El Desafío
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Tu marca ya tiene trayectoria.{" "}
            <span className="text-gradient-gold">Pero le falta activar su autoridad</span>
          </h2>
        </motion.div>

        {/* Intro text */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-center text-lg text-muted-foreground max-w-3xl mx-auto mb-16">
          Liderás una empresa sólida con resultados reales. Sin embargo, el mercado te juzga por lo que proyectás y tu imagen hoy está desactualizada. Estás pagando costos altísimos:
        </motion.p>

        {/* Pain points grid */}
        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto mb-16">
          {painPoints.map((point, index) => <motion.div key={point.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="group">
              <div className="bg-card rounded-2xl p-8 h-full border border-border hover:border-primary/30 transition-all duration-300 hover:shadow-lg">
                <div className="flex items-start gap-5">
                  {/* Icon */}
                  <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <point.icon className="w-6 h-6 text-primary" />
                  </div>
                  
                  {/* Content */}
                  <div>
                    <h3 className="font-display text-xl font-semibold mb-3 text-muted-foreground">
                      {point.title}
                    </h3>
                    <p className="leading-relaxed text-charcoal-dark">
                      {point.description}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Closing statement */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-center font-display text-xl md:text-2xl italic max-w-3xl mx-auto">
          El prestigio de tu organización debe ser tu{" "}
          <span className="font-semibold not-italic text-accent">mayor activo de ventas.</span>
        </motion.p>
      </div>
    </section>;
};
export default Challenge;